import warrantyUa from "../../img/warranty-ukr.png"
import warrantyEn from "../../img/warranty-en.png"

const Warranty = () => {
  return (
    <div className=" bg-[#F6FBFF] py-2 xs:py-0 mt-16 md:mt-20 lg:mt-24">
      <div className="max-w-[1110px] mx-auto h-[210px] tn:h-[250px] xs:h-[270px] sm:h-[340px] md:h-[380px] lg:h-[400px] flex flex-col xs:flex-row items-center justify-around">
        <div className="text-[#015198] text-xl tn:text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold tracking-[.4em] tn: xs: sm: md: lg:leading-[3.5rem]">
          ГАРАНТІЯ
          <br />
          ЯКОСТІ!
        </div>

        <img
          src={warrantyUa}
          className="w-[180px] tn:w-[220px] sm:w-[250px] md:w-[270px] lg:w-[290px]"
        />
      </div>
    </div>
  )
}

export default Warranty
